import clsx from 'clsx';

import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { ArrowBackIcon } from '@atom/mui/icons';

import { View } from '../TeamContext';

import classes from './timeHeaders.module.css';

interface Props {
  title: string;
  showBackButton?: boolean;
}

const TitleHeader = ({ title, showBackButton }: Props) => {
  const [, { updateSearchParams }] = useNavigation({
    view: SearchParamType.STRING,
  });

  const handleClick = () => {
    updateSearchParams(
      {
        view: View.TIME_SHEET_LIST,
        timeSheetUserId: null,
        timeSheetUserName: null,
      },
      false,
    );
  };

  const titleStyle = clsx(classes.title, showBackButton && classes.fullName);

  return (
    <div className={classes.timeSheetHeader}>
      {showBackButton && (
        <IconButton onClick={handleClick}>
          <Icon icon={ArrowBackIcon} />
        </IconButton>
      )}
      <div className={titleStyle}>{title}</div>
    </div>
  );
};

export default TitleHeader;
